import { Fragment, forwardRef } from 'react'

import { breakpoints } from 'styles/mq'
import { TextContainer } from 'components/container'
//import { Title } from 'components/misc'
import { Ornament2 } from './ornament-2'
import { Ornament1 } from './ornament-1'
import { Ornament3 } from './ornament-3'
import { Ornament4 } from './ornament-4'
import { Ornament5 } from './ornament-5'
import { Ornament6 } from './ornament-6'
import { Figcaption, Figure, Title } from './styled'

const images = [
  {
    label: 'Вы удивитесь, но это — шаньга',
    smallImage: require('./assets/small/slice1.webp'),
    largeImage: require('./assets/large/slice1.webp'),
    component: Ornament1,
  },
  {
    label: 'А это — следы малых зверей',
    smallImage: require('./assets/small/slice2.webp'),
    largeImage: require('./assets/large/slice2.webp'),
    component: Ornament2,
  },
  {
    label: 'Компас',
    smallImage: require('./assets/small/slice3.webp'),
    largeImage: require('./assets/large/slice3.webp'),
    component: Ornament3,
  },
  {
    label: 'Молодой олень',
    smallImage: require('./assets/small/slice4.webp'),
    largeImage: require('./assets/large/slice4.webp'),
    component: Ornament4,
  },
  {
    label: 'Кочка с ягодами — о такую приятно и споткнуться',
    smallImage: require('./assets/small/slice5.webp'),
    largeImage: require('./assets/large/slice5.webp'),
    component: Ornament5,
  },
  {
    label: 'Оленевод',
    smallImage: require('./assets/small/slice6.webp'),
    largeImage: require('./assets/large/slice6.webp'),
    component: Ornament6,
  },
]

export const Ornaments = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref}>
    <TextContainer>
      <Title data-menu-title="орнаменты коми">Орнаменты Коми</Title>
      <p>
        Коми также создали свои уникальные орнаменты. Они часто изображаются на
        одежде, обуви, предметах домашнего обихода. Орнамент представляет собой
        определенную последовательность узора, который складывается в истории о
        важных моментах повседневной жизни: охоте, божественных историях, любви
        или траурных событиях.
      </p>

      {images.map(image => (
        <Fragment key={image.label}>
          {image.component ? (
            <Figure as="div">
              <image.component />
              <Figcaption as="p">{image.label}</Figcaption>
            </Figure>
          ) : (
            <Figure>
              <picture>
                <source srcSet={image.largeImage} media={breakpoints.medium} />
                <img src={image.smallImage} alt={image.label} />
              </picture>
              <Figcaption>{image.label}</Figcaption>
            </Figure>
          )}
        </Fragment>
      ))}
    </TextContainer>
  </section>
))
